import React from 'react';
import { useForm } from 'react-hook-form';
import { z } from 'zod';

import LanguagesSearchSelect from '../controls/LanguagesSearchSelect';
import NavRow from '../fields/NavRow';
import { TaskDefinition, TaskStepRenderArgs } from '../QuestionnaireShell';
import { LanguagesValues } from '../types';
import { zodResolver } from '../validation';

const schema = z.object({
  languages: z.array(z.object({ title: z.string(), value: z.string() })),
});

const DEFAULTS: LanguagesValues = { languages: [] };

const LanguagesForm = ({ initialValues, onComplete, onBack, onCancelEdit, submitLabel }: TaskStepRenderArgs) => {
  const defaults = (initialValues as LanguagesValues | undefined) ?? DEFAULTS;
  const {
    control,
    handleSubmit,
    formState: { isValid },
  } = useForm<LanguagesValues>({
    defaultValues: defaults,
    resolver: zodResolver(schema),
    mode: 'onChange',
  });

  const onSubmit = handleSubmit((values) => onComplete(values));

  return (
    <form className="rnq-form" onSubmit={(e) => e.preventDefault()} style={{ marginTop: '1rem' }}>
      <LanguagesSearchSelect control={control} name="languages" />
      <NavRow
        onBack={onBack}
        onCancelEdit={onCancelEdit}
        onSubmit={onSubmit}
        submitLabel={submitLabel}
        disabled={!isValid}
      />
    </form>
  );
};

const Languages: TaskDefinition = {
  key: 'task12',
  label: 'Languages',
  title: 'What languages do you speak?',
  description:
    'LegalShield provides multilingual services in addition to English. Please add any further languages you are willing to provide services in.',
  render: (args) => <LanguagesForm {...args} />,
};

export default Languages;
